import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledContainerProps {
  height?: string;
  margintop?: string;
  gap?: number;
}

export const StyledContainer = styled(Paper)<StyledContainerProps>(
  ({ theme, margintop, gap = 3 }) => ({
    width: '100%',
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(gap),
    height: '488px',
    margintop,
    [theme.breakpoints.down('xmd')]: {
      height: '560px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
  })
);
